import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  Box,
  Typography,
} from '@mui/material';
import '../../styles/signUpDialog.css'
import googlelogo from '../../images/googlelogo.png'
import ldlogo from '../../images/linkdinlogo.png'
import fblogo from '../../images/fblogo.png'
import { useState } from 'react';
import SignUpAs from './SignUpAs';
import LoginModal from './LoginModal';
import { useGoogleLogin } from '@react-oauth/google';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import CloseIcon from '@mui/icons-material/Close';
import { border } from '@mui/system';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { useDispatch } from 'react-redux';
import { googleLogin, linkedInLogin } from '../../actions/userAuth';
import RegisterModal from './RegisterModal';
import axios from 'axios';

export default function SignUp({ role, addSignUpAction, setAddSignUpAction }) {
  const [addRegisterModalAction, setAddRegisterModalAction] = useState(false)
  const dispatch = useDispatch();

  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      // fetching userinfo can be done on the client or the server
      console.log(tokenResponse);
      const userInfo = await axios
        .get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then(res => res.data);

      console.log(userInfo);
      dispatch(googleLogin({ tokenId: tokenResponse.access_token, role }, (data) => {
        console.log(data);
      }, (err) => {
        console.log(err);
      }))
    }
  });

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setAddSignUpAction(false);
  }


  const handleLogin = () => {
    linkedInLogin();
  }

  return (
    <>

      <Dialog

        open={addSignUpAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
        TransitionComponent={Fade}
        transitionDuration={500}
        sx={{ borderRadius: '100px' }}
      >
        <DialogTitle >
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent  >
          <div className="signUpModal">
            <div className="signUpModal-box">
              <div className="signUpModal-content">
                <div className="signUpModal-body">
                  <span className="signUpModal-span1">Join us to sign in!</span>
                  <div onClick={() => login()} className="signUpModal-div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }} >
                    <span>
                      <img src={googlelogo} className="signUpModal-icon" alt="img" />
                    </span>
                    <span className="signUpModal-span2">Sign up with Google</span>

                  </div>
                  <div onClick={handleLogin} className="signUpModal-div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                    <span>
                      <img src={ldlogo} className="signUpModal-icon" alt="img" style={{ borderRadius: 20 }} />
                    </span>
                    <span className="signUpModal-span2">Sign up with LinkedIn</span>
                  </div>
                  <div className="signUpModal-div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }} >
                    <span>
                      <img src={fblogo} className="signUpModal-icon" alt="img" />
                    </span>
                    <FacebookLogin
                      appId="630449715710921"
                      style={{
                        backgroundColor: '#fff',
                        color: '#000',
                        fontSize: '16px',
                        border: 'none',
                      }}
                      children="Sign up with facebook"
                      onSuccess={(response) => {
                        console.log('Login Success!', response);
                      }}
                      onFail={(error) => {
                        console.log('Login Failed!', error);
                      }}
                      onProfileSuccess={(response) => {
                        console.log('Get Profile Success!', response);
                      }}
                    />
                  </div>

                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    onClick={() => { setAddSignUpAction(false); setAddRegisterModalAction(true) }}
                    sx={{ bgcolor: "#2544EE", mt: 2, borderRadius: 2, textTransform: 'none', fontSize: 16 }}

                  >
                    Signup with Email
                  </Button>
                </div>
              </div>
            </div>
          </div>

        </DialogContent>
      </Dialog>
      <RegisterModal
        role={role}
        addRegisterModalAction={addRegisterModalAction}
        setAddRegisterModalAction={setAddRegisterModalAction}
      />
    </>
  );
}
